import { useEffect } from 'react';
import { registerNativePushListeners, requestAndRegisterNativePush, syncNotificationsOptIn, syncPushTokenForUser } from '@/lib/pushNotifications';

export function useStartupNotifications(enabled: boolean, userId?: string | null) {
	useEffect(() => {
		if (!userId) return;

		void registerNativePushListeners();
		if (!enabled) return;

		void requestAndRegisterNativePush(async (token) => {
			await syncPushTokenForUser(userId, token);
			await syncNotificationsOptIn(userId, true);
		});
	}, [enabled, userId]);
}